module.exports = __webpack_public_path__ + "img/sealCollectionHed.13a6a2c9.png";